// extracted by mini-css-extract-plugin
export var infoBox = "index-module--infoBox--2W0ZQ";
export var infoLine = "index-module--infoLine--1iu_c";
export var thirdParty = "index-module--thirdParty--1BwZy";